// extracted by mini-css-extract-plugin
export default {"container":"styles_container__o3kd5","photo":"styles_photo__2S4XC","actions":"styles_actions__CIkwW","information":"styles_information__tOEJ2"};